import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';

// ─── Remove a user from a company ──────────────────────────────────────────

interface RemoveUserFromCompanyPayload {
  /** UID of the user to remove */
  user_uid: string;
  /** ID of the company to remove the user from */
  company_id: string;
  /** API key of the company (for company-level security) */
  company_api_key: string;
}

interface RemoveUserFromCompanyResponse {
  user_uid: string;
  company_id: string;
  unassigned_subscriptions: string[];
}

/**
 * Remove a user from a company: un-assign from all company subscriptions
 * and remove the company from the user's id_companies.
 */
export async function removeUserFromCompany(
  payload: RemoveUserFromCompanyPayload,
  auth: Authentication,
): Promise<RemoveUserFromCompanyResponse> {
  try {
    const response = await HttpClient.post(
      '/company/remove-user',
      {
        user_uid: payload.user_uid,
        company_id: payload.company_id,
      },
      auth.token,
      false,
      {
        'x-api-key': payload.company_api_key,
        'x-user-uid': auth.id,
      }
    );

    return response.data;
  } catch (e) {
    console.error('removeUserFromCompany error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new RemoveUserFromCompanyFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new RemoveUserFromCompanyFailure(e.message);
    }
    return Promise.reject(e);
  }
}

// ─── Failure class ───────────────────────────────────────────────────────────

export class RemoveUserFromCompanyFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

